/*!
=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================
* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import Dashboard from "views/Dashboard.jsx";
import AddCategory from "views/Forms/category/addCategory";
import EditCategory from "views/Forms/category/editcategory";
import Addhealthcondition from "views/Forms/healthcondition/addhealthcondition";
import Edithealthcondition from "views/Forms/healthcondition/edithealthcondition";
import Viewhealthcondition from "views/Forms/healthcondition/viewhealthconditionlist";
import InventoryManagement from "views/Forms/Inventory/addInventory";
import InventoryList from "views/Forms/Inventory/viewInventoryList";
import EditInventoryManagement from "views/Forms/Inventory/editInventoryManagement";
import activityDetails from "views/Forms/Activities/activityDetails";
import addCredirt from "views/Forms/AddCredit/addcredit";
// import NotificationWindow from  'views/Forms/order/window_notification';
import AddMedication from "views/Forms/medication/addmedication";
import ViewMedication from "views/Forms/medication/viewmedication";
import EditMedication from "views/Forms/medication/editmedication";

import ViewExpiryMedication from "views/Forms/ExpiryMedicine/expiryMedicineList";
import Claim from "views/Forms/Claim/claimList";
import userManagement from "views/Forms/UserManagement/userManagement";
import transaction from "views/Forms/Transaction/transaction";
import logs from "views/Forms/Logs/logs";
import contact from "views/Forms/Contact/contact";
import claimEmployeeList from "views/Forms/ClaimEmployeeList/claimEmployeeList";

import AddCouponCode from "views/Forms/coupons/addCouponCode";
import ViewCouponCode from "views/Forms/coupons/viewCouponCode";
import EditCouponCode from "views/Forms/coupons/editCouponCode";
import UseCouponCode from "views/Forms/coupons/useCoupon";

import AddVoucher from "views/Forms/Voucher/addVoucher";
import ViewVoucher from "views/Forms/Voucher/viewVoucher";
import EditVoucher from "views/Forms/Voucher/editVoucher";

import Consultations from "views/Forms/Consultation/consultaions";

import AddGroup from "views/Forms/groups/addGroup";
import EditGroup from "views/Forms/groups/editGroup";
import ViewGrops from "views/Forms/groups/viewGroups";

import AddSpeciality from "views/Forms/Speciality/addSpecility";
import EditSpeciality from "views/Forms/Speciality/editSpecility";
import ViewSpeciality from "views/Forms/Speciality/viewSpecility";

//import AddAppointment from "views/Forms/Appoinement/addAppointments";
//import EditAppointment from "views/Forms/Appoinement/editAppointments";
import ViewAppointment from "views/Forms/Appoinement/viewAppointments";

//import AddSlot from 'views/Forms/Schedule/DoctorSchedule/AddSchedule'
import EditSlot from "views/Forms/Schedule/DoctorSchedule/EditSchedule";
import ViewSlot from "views/Forms/Schedule/DoctorSchedule/ViewSchedule";

import AddGlobal from "views/Forms/Schedule/GlobalSchedule/AddGlobalSchedule";
import EditGlobal from "views/Forms/Schedule/GlobalSchedule/EditGlobalSchedule";
import ListGlobal from "views/Forms/Schedule/GlobalSchedule/GlobalSchedule";

//import DonorList from "views/Forms/DonorList/donorList";
import VoucherDonorList from "views/Forms/DonerVoucher/DonerVoucher";
import AddDonorVoucher from "views/Forms/DonerVoucher/addDonorVoucher";

import AddNotification from "views/Forms/notifications/addNotification";
import EditNotification from "views/Forms/notifications/editNotification";
import ViewNotifications from "views/Forms/notifications/viewNotifications";
import SendBulkNotifictaion from "views/Forms/notifications/sendNotification";

import Order from "views/Forms/order/addorder";
import OrderNew from "views/Forms/order/addorderNew";
import RiderLocation from "views/Forms/Rider/rider";
import RiderLocationOld from "views/Forms/Rider/riderOld";
import RiderDistance from "views/Forms/Rider/riderDistance";
import RiderDistanceOld from "views/Forms/Rider/riderDistanceOld";
import OrderList from "views/Forms/order/orderlist";
import UpcomingOrder from "views/Forms/order/upcomingOrder";
import EditOrder from "views/Forms/order/editOrder";
import EditOrderNew from "views/Forms/order/editOrderNew";
import OrderCreditNote from "views/Forms/order/orderCreditNote";
import ReplicateOrder from "views/Forms/order/replicateOrder";
import AddLabOrder from "views/Forms/LabOrder/addlaborder";
import LabOrderList from "views/Forms/LabOrder/laborderlist";
import EditLabOrder from "views/Forms/LabOrder/editlabOrder";
import Subcription from "views/Forms/Subscription/addsubscription";
import ViewSubcription from "views/Forms/Subscription/viewsubscription";
import EditSubcription from "views/Forms/Subscription/editsubscription";
import EditCommision from "views/Forms/medication/editcommision";
import Lead from "views/Forms/lead/addlead";
import LeadDeails from "views/Forms/lead/viewlead";
import Settingdetails from "views/Forms/settingsdata/settings_list";
import EditSetting from "views/Forms/settingsdata/editsetting";
import Packagelist from "views/Forms/LabPackage/packagelist";
import Editpackage from "views/Forms/LabPackage/editpackage";
import Addpackage from "views/Forms/LabPackage/addpackage";
import ReportList from "views/Forms/LabReport/reportlist";
import AddReport from "views/Forms/LabReport/addreport";
import EditReport from "views/Forms/LabReport/editreport";
import Addb2b from "views/Forms/B2B/addb2b";
import B2Blist from "views/Forms/B2B/b2blist";
import Editb2b from "views/Forms/B2B/editb2b";
import UserList from "views/Forms/Users/userlist";
import UserLog from "views/Forms/Userlog/userlog";
import AddUser from "views/Forms/Users/adduser";
import EditUser from "views/Forms/Users/edituser";
import EditLead from "views/Forms/lead/editlead";
import BulkImport from "views/Forms/bulkImport/medicationOrder";
import LeadImport from "views/Forms/bulkImport/lead";
import FamilyBulkImport from "views/Forms/bulkImport/familyBulk";
import TeamBulkImport from "views/Forms/bulkImport/team&TeamMembersBulk";
import LabOrderImport from "views/Forms/bulkImport/labOrder";
import MedicineImport from "views/Forms/bulkImport/medication";
import DoctorPayOuts from "views/Forms/bulkImport/doctorPayouts";
import AllMedicationcategory from "views/Forms/category/viewcategory";
import LoginPage from "views/Pages/LoginPage.jsx";
import RegisterPage from "views/Pages/RegisterPage.jsx";
import NotFoundPage from "views/Tables/RegularTables.jsx";

import viewhealthtopic from "views/Forms/healthtopic/viewhealthtopic";
import addhealthtopic from "views/Forms/healthtopic/addhealthtopic";
import edithealthtopic from "views/Forms/healthtopic/edithealthtopic";

import Banner from "views/Forms/Banner/viewBanner";
import AddBanner from "views/Forms/Banner/addBanner";
import EditBanner from "views/Forms/Banner/editBanner";

import viewMedicationTags from "views/Forms/medicationTags/viewMedicationTags";
import addMedicationTags from "views/Forms/medicationTags/addMedicationTags";
import editMedicationTags from "views/Forms/medicationTags/editMedicationTags";

import viewSubscriptionpackage from "views/Forms/SubscriptionPackage/viewsubscriptionpackage";
import editsubscriptionpackage from "views/Forms/SubscriptionPackage/editsubscriptionpackage";
import addnewsubscriptionpackage from "views/Forms/SubscriptionPackage/addsubscriptionpackage";
import subscriptionorderlist from "views/Forms/Subscriptionorder/subscriptionorderlist";
import addsubscriptionorder from "views/Forms/Subscriptionorder/addsubscriptionorder";
import editsubscriptionOrder from "views/Forms/Subscriptionorder/editsubscriptionOrder";
import subscriptionpackagefilter from "views/Forms/Subscriptionorder/subscriptionpackagefilter/subscriptiopackagefilter";
import labridertracker from "views/Forms/Labridertracking/labridertracker";

import ForgotPage from "views/Pages/ForgotPage";
import ResetPage from "views/Pages/resetPassword";

import ProductCatalogueActivity from "views/Forms/ProductCatalogue/PackageActivity";
import ProductCatalogue from "views/Forms/ProductCatalogue/addProductCatalogue";
import AddProductCatalogueNew from "views/Forms/ProductCatalogue/AddProductCatalogue/addProductCatalogueNew";
import EditProductCatalogueNew from "views/Forms/ProductCatalogue/AddProductCatalogue/editProductCatalogueNew";
import EditProductCatalogue from "views/Forms/ProductCatalogue/editProductCatalogue";
import ProductCatalogueDeails from "views/Forms/ProductCatalogue/viewProductCatalogue";
import replicateProductCatalogue from "views/Forms/ProductCatalogue/replicateProductCatalogue";
import DeliveryType from "views/Forms/DeliveryType/addDeliveryType";
import EditDeliveryType from "views/Forms/DeliveryType/editDeliveryType";
import DeliveryTypeDeails from "views/Forms/DeliveryType/viewDeliveryType";

import XeroInvoice from "views/Forms/XeroInvoice/xeroInvoice";
import ProductUtility from "views/Forms/ProductUtility/productUtility";
import Productconsultation from "views/Forms/ProductConsultation/productConsultation";

import ViewTickets from "views/Forms/Ticket/viewTickets";
import AddTicket from "views/Forms/Ticket/addTicket";
import EditTicket from "views/Forms/Ticket/editTicket";
import PoList from "views/Forms/PoList/poList";
import AddPo from "views/Forms/PoList/addPo";
import EditPo from "views/Forms/PoList/editPo";
import DoctorEarningRedeemView from "views/Forms/DoctorEarningsRedeem/doctorEarningRedeemView";
import ViewLightHouseCategory from "views/Forms/LightHouse/categories";
import ViewLightHouseTemplate from "views/Forms/LightHouse/templates";
import ViewLightHouseSubCategories from "views/Forms/LightHouse/subCategories";
import Country from "views/Forms/Country/country";
import AddCountry from "views/Forms/Country/addCountry";
import ConsultationLogs from "views/ConsultationLogs/consultationLogs";
import ViewCreditNote from "views/Forms/order/orderCreditNote";
import ProductList from "views/Forms/ProductList/ProductList";
import AddProductList from "views/Forms/ProductList/AddProductList";
import GoodReturnNote from "views/Forms/GoodReturnNote/goodReturnNote";
import ClaimReport from "views/Forms/Reports/claimReports";
import SavingsCalculator from "views/Pages/SavingsCalculator";
import Challengers from "views/Forms/Challengers/challengers";
import editChallenge from "views/Forms/Challengers/editChallenge";
import addchallenge from "views/Forms/Challengers/addChallengers";
import leadsBulkUpload from "views/Forms/bulkImport/leadsBulkUpload";
import WarehouseInventoryDispatch from "views/Forms/WarehouseInventoryDispatch/WarehouseInventoryDispatchList/warehouseInventoryList";
import AddWarehouseInventoryDispatch from "views/Forms/WarehouseInventoryDispatch/AddWarehouseInventoryDispatch/addWarehouseInventoryDispatch";
import EditWarehouseInventoryDispatch from "views/Forms/WarehouseInventoryDispatch/EditWarehouseInventoryDispatch/editWarehouseInventoryDispatch";
import claimReconciliation from "views/Forms/ClaimReconciliation/claimReconciliation";
import removeFlashCredit from "views/Forms/removeFlashCredit/removeFlashCredit";

// import CustomerList from "views/Forms/Customer/customerMain";
// import InventoryTabList from "views/Forms/InventoryTab/inventoryTabs";
// import ProductCatalogueList from "views/Forms/ProductCatalogue/viewProductCatalogue";
// import ViewGroups from "views/Forms/groups/viewGroups";
// import ViewAppointmentList from "views/Forms/Appoinement/viewAppointments";
// import CouponVoucherList from "views/Forms/coupons/viewCouponCode";
// import DoctorTab from "views/Forms/Doctor/doctorTabs";
// import VoucherDonorLists from "views/Forms/DonerVoucher/DonerVoucher";
// import FlashCredit from "views/Forms/AddCredit/addcredit";
// import AppContentTabs from "views/Forms/AppContent/appContentTabs";
// import BulkMedicine from "views/Forms/bulkImport/medicationOrder";
// import BulkCustomer from "views/Forms/bulkImport/lead";
// import BulkLab from "views/Forms/bulkImport/labOrder";
// import XeroInvoices from "views/Forms/XeroInvoice/xeroInvoice";
// import SystemLog from "views/Forms/Userlog/userlog";
// import AppLog from "views/Forms/Activities/activityDetails";
// import RiderLogTab from "views/Forms/RiderLog/riderLog";
// import PurchaseOrderList from "views/Forms/PoList/poList";
import ViewPurchaseRequest from "views/Forms/PurchaseRequest/viewPurchaseRequest";
import AddPurchaseRequestForm from "views/Forms/PurchaseRequest/AddPurchaseRequestForm";
import EditPurchaseRequest from "views/Forms/PurchaseRequest/EditPurchaseRequest";
import getRelatedStore from "views/Forms/RelatedStore/getRelatedStore";
import BannerList from "views/Forms/BannerNotice/bannerNoticerList";
import AddBannerNotice from "views/Forms/BannerNotice/addBannerNotice.jsx/addBannerNotice";
import EditBannerNotice from "views/Forms/BannerNotice/editBannerNotice.jsx/editBannerNotice";
import returnNoteBulkUpload from "views/Forms/bulkImport/goodReturnBulkUpload";
import EditUserPo from "views/Forms/PoList/EditUser/editUserPo";
import StoreRequest from "views/Forms/StoreRequest/storeRequest";
import MedicineWiseOrder from "views/Forms/PurchaseRequest/MedicineWiseOrder";
import AddPickUpOrderModal from "views/Forms/order/pickUpModal/addPickUpOrderModal";
import EditPickUpOrderModal from "views/Forms/order/pickUpModal/editPickUpModal";
// import AuthorizationLevel from "views/Forms/RefilLRequestAuthorization/authorizationLevel";
import AddPoNew from "views/Forms/PoList/addPoNew";
import EditPoNew from "views/Forms/PoList/editPoNew";
// import AddPRRequest from "views/Forms/StoreRequest/addPrRequest";

var routes = [
  {
    path: "/login-page",
    layout: "/auth",
    name: "Login Page",
    mini: "LP",
    component: LoginPage,
    isDisplay: "no",
  },
  {
    path: "/forgot-password-page",
    layout: "/auth",
    name: "Forgot Password",
    mini: "FP",
    component: ForgotPage,
    isDisplay: "no",
  },
  {
    path: "/password/reset/:token",
    layout: "/auth",
    name: "Reset Password",
    mini: "RP",
    component: ResetPage,
    isDisplay: "no",
  },
  {
    path: "/register-page",
    layout: "/auth",
    name: "Register",
    mini: "RP",
    component: RegisterPage,
    isDisplay: "no",
  },
  {
    path: "/notfount",
    layout: "/auth",
    name: "notfount",
    mini: "RP",
    component: NotFoundPage,
    isDisplay: "no",
  },

  {
    path: "/dashboard",
    layout: "/admin",
    name: "Dashboard",
    icon: "pe-7s-graph",
    component: Dashboard,
    isDisplay: "yes",
  },
  // {
  //   path: "/storeRequest",
  //   layout: "/admin",
  //   name: "Store Request",
  //   icon: "glyphicon glyphicon-align-justify",
  //   component: StoreRequest,
  //   isDisplay: "yes",
  // },
  // {
  //   path: "/add-store-request",
  //   layout: "/admin",
  //   name: "Store Request",
  //   icon: "glyphicon glyphicon-align-justify",
  //   component: AddPRRequest,
  //   isDisplay: "no",
  // },

  {
    collapse: true,
    path: "/order",
    name: "Orders",
    state: "openOrder",
    icon: "pe-7s-note2",
    views: [
      {
        path: "/add-order/:id",
        layout: "/admin",
        name: "New Order ",
        breadcrumb: "All Orders",
        breadcrumbPath: "order_list",
        mini: "OR",
        icon: "fa fa-clone",
        component: Order,
        isDisplay: "no",
      },
      {
        path: "/add-order",
        layout: "/admin",
        name: "New Order ",
        breadcrumb: "All Orders",
        breadcrumbPath: "order_list",
        mini: "OR",
        icon: "fa fa-clone",
        component: Order,
        isDisplay: "no",
      },
      {
        path: "/add-order-2",
        layout: "/admin",
        name: "New Order ",
        breadcrumb: "All Orders",
        breadcrumbPath: "order_list",
        mini: "OR",
        icon: "fa fa-clone",
        component: OrderNew,
        isDisplay: "no",
      },
      {
        path: "/order_list",
        layout: "/admin",
        name: "Medicine Order",
        mini: "OD",
        icon: "fa fa-medkit",
        component: OrderList,
        isDisplay: "yes",
        role: [11, 13, 18],
      },
      {
        path: "/poList",
        layout: "/admin",
        name: "Purchase Order",
        icon: "fa fa-sliders",
        component: PoList,
        isDisplay: "no",
      },
      {
        path: "/credit_note/:id",
        layout: "/admin",
        name: "Medicine",
        mini: "OU",
        icon: "fa fa-medkit",
        component: ViewCreditNote,
        isDisplay: "no",
      },
      {
        path: "/upcoming_order",
        layout: "/admin",
        name: "Upcoming Orders",
        mini: "OU",
        icon: "pe-7s-news-paper",
        component: UpcomingOrder,
        isDisplay: "no",
      },

      {
        path: "/order/:id",
        layout: "/admin",
        name: "Edit Order",
        mini: "ER",
        breadcrumb: "All Orders",
        breadcrumbPath: "order_list",
        icon: "pe-7s-news-paper",
        component: EditOrder,
        isDisplay: "no",
      },
      {
        path: "/order-new/:id",
        layout: "/admin",
        name: "Edit Order New",
        mini: "ER",
        breadcrumb: "All Orders",
        breadcrumbPath: "order_list",
        icon: "pe-7s-news-paper",
        component: EditOrderNew,
        isDisplay: "no",
      },
      {
        path: "/replicate-order/:id",
        layout: "/admin",
        name: "Replicate Order",
        mini: "ER",
        breadcrumb: "All Orders",
        breadcrumbPath: "order_list",
        icon: "pe-7s-news-paper",
        component: ReplicateOrder,
        isDisplay: "no",
      },
      {
        path: "/credit_note/:id",
        layout: "/admin",
        name: "Credit Note",
        mini: "OU",
        icon: "fa fa-medkit",
        breadcrumb: "Edit Order",
        breadcrumbPath: "All Orders",
        component: OrderCreditNote,
        isDisplay: "no",
      },
      {
        path: "/add-pickUp",
        layout: "/admin",
        name: "New-Pick-Order ",
        breadcrumb: "All Orders",
        breadcrumbPath: "order_list",
        mini: "OR",
        icon: "fa fa-clone",
        component: AddPickUpOrderModal,
        isDisplay: "no",
      },
      {
        path: "/edit-pickUp/:id",
        layout: "/admin",
        name: "Edit-Pick-Order",
        mini: "OR",
        breadcrumb: "All Orders",
        breadcrumbPath: "order_list",
        icon: "pe-7s-news-paper",
        component: EditPickUpOrderModal,
        isDisplay: "no",
      },
      {
        collapse: true,
        path: "/order ",
        name: "Lab",
        state: "openorderlab",
        icon: "fa fa-flask",
        views: [
          {
            path: "/lab-add-order/:id",
            layout: "/admin",
            name: "New Lab Order ",
            breadcrumb: "Lab OrderList",
            breadcrumbPath: "lab_order_list",
            mini: "OR",
            icon: "fa fa-clone",
            component: AddLabOrder,
            isDisplay: "no",
          },

          {
            path: "/lab-add-order",
            layout: "/admin",
            name: "New Lab Order ",
            breadcrumb: "Lab OrderList",
            breadcrumbPath: "lab_order_list",
            mini: "OR",
            icon: "fa fa-clone",
            component: AddLabOrder,
            isDisplay: "no",
          },
          {
            path: "/lab_order_list",
            layout: "/admin",
            name: "Lab",
            mini: "OD",
            icon: "fa fa-flask",
            component: LabOrderList,
            isDisplay: "yes",
          },

          {
            path: "/laborder/:id",
            layout: "/admin",
            name: "Edit Lab Order",
            mini: "ER",
            breadcrumb: "Lab OrderList",
            breadcrumbPath: "lab_order_list",
            icon: "pe-7s-news-paper",
            component: EditLabOrder,
            isDisplay: "no",
          },
          {
            path: "/banner",
            layout: "/admin",
            name: "Banner",
            mini: "OBR",
            icon: "fa fa-clone",
            component: Banner,
            isDisplay: "yes",
          },
          {
            path: "/addbanner",
            layout: "/admin",
            name: "Add Banner",
            mini: "OBRA",
            icon: "fa fa-clone",
            component: AddBanner,
            isDisplay: "no",
          },
          {
            path: "/editbanner",
            layout: "/admin",
            name: "Edit Banner",
            mini: "OBRE",
            icon: "fa fa-clone",
            component: EditBanner,
            isDisplay: "no",
          },
        ],
      },
      {
        collapse: true,
        path: "/order ",
        name: "Subscription",
        state: "openordersubscription",
        icon: "pe-7s-note2",
        views: [
          {
            path: "/subscription-add-order/:id",
            layout: "/admin",
            name: "New Subscription Order ",
            breadcrumb: "Subscription OrderList",
            breadcrumbPath: "subscription_order_list",
            mini: "OR",
            icon: "fa fa-clone",
            component: addsubscriptionorder,
            isDisplay: "no",
          },

          {
            path: "/subscription-add-order",
            layout: "/admin",
            name: "New Subscription Order ",
            breadcrumb: "Subscription OrderList",
            breadcrumbPath: "subscription_order_list",
            mini: "OR",
            icon: "fa fa-clone",
            component: addsubscriptionorder,
            isDisplay: "yes",
          },
          {
            path: "/subscription_order_list",
            layout: "/admin",
            name: "Subscription OrderList",
            mini: "OD",
            icon: "pe-7s-news-paper",
            component: subscriptionorderlist,
            isDisplay: "yes",
          },
          {
            path: "/subscriptionfilter",
            layout: "/admin",
            name: "Subscription Details",
            mini: "SD",
            component: subscriptionpackagefilter,
            icon: "fa fa-user",
            isDisplay: "yes",
          },
          {
            path: "/subscriptionorder/:id",
            layout: "/admin",
            name: "Edit Subscription Order",
            mini: "ER",
            breadcrumb: "Subscription OrderList",
            breadcrumbPath: "subscription_order_list",
            icon: "pe-7s-news-paper",
            component: editsubscriptionOrder,
            isDisplay: "no",
          },
        ],
      },
      {
        path: "/edit_b2b",
        layout: "/admin",
        name: "Edit B2B",
        mini: "BL",
        component: Editb2b,
        breadcrumb: "B2B",
        breadcrumbPath: "viewb2b",
        icon: "fa fa-cubes",
        isDisplay: "no",
      },
      {
        path: "/consultations",
        layout: "/admin",
        name: "Consultations (First Advise)",
        mini: "CLS",
        component: Consultations,
        icon: "fa fa-hospital-o",
        isDisplay: "yes",
      },
      {
        path: "/search-consultation-logs",
        layout: "/admin",
        name: "Search Consultation Logs",
        mini: "SCL",
        breadcrumb: "Search Consultation Logs",
        breadcrumbPath: "search-consultation-logs",
        component: ConsultationLogs,
        isDisplay: "no",
      },
    ],
  },
  {
    collapse: true,
    path: "/management",
    name: "Management",
    state: "openManagement",
    icon: "pe-7s-config",
    views: [
      {
        collapse: true,
        path: "/lead ",
        name: "Customers/Org",
        state: "openLead",
        icon: "fa fa-user-plus",
        views: [
          {
            path: "/lead",
            layout: "/admin",
            name: "B2C List",
            mini: "LD",
            icon: "pe-7s-ball",
            component: LeadDeails,
            isDisplay: "yes",
          },
          {
            path: "/addlead",
            layout: "/admin",
            name: "Add B2C Customer",
            breadcrumb: "Leads",
            breadcrumbPath: "lead",
            mini: "LE",
            icon: "pe-7s-note",
            component: Lead,
            isDisplay: "no",
          },

          {
            path: "/editlead",
            layout: "/admin",
            name: "Edit Customers",
            mini: "LD",
            breadcrumb: "Leads",
            breadcrumbPath: "lead",
            component: EditLead,
            isDisplay: "no",
          },
          {
            path: "/viewb2b",
            layout: "/admin",
            name: "B2B List",
            mini: "BL",
            component: B2Blist,
            icon: "fa fa-building",
            isDisplay: "yes",
          },
          {
            path: "/addb2b",
            layout: "/admin",
            name: "Add B2B Organization",
            mini: "b2b",
            icon: "fa fa-cubes",
            breadcrumb: "B2B",
            breadcrumbPath: "viewb2b",
            component: Addb2b,
            isDisplay: "no",
          },
        ],
      },
      {
        collapse: true,
        path: "/Challengers ",
        name: "Challengers",
        state: "openChallenge",
        icon: "fa fa-handshake-o",
        views: [
          {
            path: "/Challengers",
            layout: "/admin",
            name: "Challengers",
            mini: "CHL",
            icon: "fa fa-hand-peace-o",
            component: Challengers,
            isDisplay: "yes",
          },
          {
            path: "/editChallenge",
            layout: "/admin",
            name: "Edit Challengers",
            component: editChallenge,
            isDisplay: "no",
            mini: "EC",
            breadcrumb: "Challengers",
            breadcrumbPath: "/admin/Challengers",
          },
          {
            path: "/addChallenge",
            layout: "/admin",
            name: "Add Challengers",
            component: addchallenge,
            isDisplay: "no",
            mini: "AC",
            breadcrumb: "Challengers",
            breadcrumbPath: "Challengers",
          },
        ],
      },
      {
        collapse: true,
        path: "/doctor ",
        name: "Doctor",
        state: "openDoctor",
        icon: "fa fa-user-md",
        views: [
          {
            path: "/globalschedule",
            layout: "/admin",
            name: "Global Schedules",
            mini: "GSL",
            component: ListGlobal,
            icon: "fa fa-gear",
            isDisplay: "yes",
          },
          {
            path: "/addglobalschedule",
            layout: "/admin",
            name: "Add Global Schedule",
            mini: "GSA",
            component: AddGlobal,
            icon: "fa fa-gear",
            isDisplay: "no",
          },
          {
            path: "/editglobalschedule",
            layout: "/admin",
            name: "Edit Global Schedule",
            mini: "GSE",
            component: EditGlobal,
            icon: "fa fa-gear",
            isDisplay: "no",
          },
          {
            path: "/speciality",
            layout: "/admin",
            name: "Groups",
            name: "Specialities",
            mini: "MVS",
            component: ViewSpeciality,
            icon: "fa fa-gear",
            isDisplay: "yes",
          },
          {
            path: "/addspeciality",
            layout: "/admin",
            name: "Add Speciality",
            mini: "MAS",
            component: AddSpeciality,
            icon: "fa fa-gear",
            isDisplay: "no",
          },
          {
            path: "/editspeciality",
            layout: "/admin",
            name: "Edit Speciality",
            mini: "MES",
            component: EditSpeciality,
            icon: "fa fa-gear",
            isDisplay: "no",
          },
          {
            path: "/doctor_schedules",
            layout: "/admin",
            name: "Doctor Schedule",
            mini: "MTS",
            component: ViewSlot,
            icon: "pe-7s-science",
            isDisplay: "yes",
          },
          {
            path: "/editschedule",
            layout: "/admin",
            name: "Edit Schedule",
            mini: "MSE",
            component: EditSlot,
            icon: "fa fa-gear",
            isDisplay: "no",
          },
          {
            path: "/doctor_earning",
            layout: "/admin",
            name: "Doctor Earning Redeem",
            mini: "MTS",
            component: DoctorEarningRedeemView,
            icon: "pe-7s-science",
            isDisplay: "yes",
          },
        ],
      },
      {
        collapse: true,
        path: "/inventory",
        name: "Inventory",
        state: "openInventory",
        icon: "pe-7s-portfolio",
        views: [
          {
            path: "/medication",
            layout: "/admin",
            name: "Medicines",
            mini: "MD",
            icon: "fa fa-medkit",
            component: ViewMedication,
            isDisplay: "yes",
          },
          {
            path: "/addmedication",
            layout: "/admin",
            name: "Add Medication ",
            mini: "AM",
            breadcrumb: "Medication",
            breadcrumbPath: "medication",
            component: AddMedication,
            isDisplay: "no",
          },
          {
            path: "/edit_medication",
            layout: "/admin",
            name: "Edit Medication",
            mini: "EM",
            breadcrumb: "Medication",
            breadcrumbPath: "medication",
            component: EditMedication,
            isDisplay: "no",
          },
          {
            path: "/expiryMedication",
            layout: "/admin",
            name: "Expiry Medicines",
            mini: "MD",
            icon: "fa fa-medkit",
            component: ViewExpiryMedication,
            isDisplay: "yes",
          },
          {
            path: "/medication-category",
            layout: "/admin",
            name: "Categories",
            mini: "MCL",
            icon: "fa fa-th-large",
            component: AllMedicationcategory,
            isDisplay: "yes",
          },
          {
            path: "/medicationTags",
            layout: "/admin",
            name: "Medication Tags (Sub Category)",
            mini: "HC",
            icon: "fa fa-medkit",
            component: viewMedicationTags,
            isDisplay: "yes",
          },
          {
            path: "/add_medication_category",
            layout: "/admin",
            name: "Add Medication Category",
            mini: "AMC",
            breadcrumb: "Medication Categories",
            breadcrumbPath: "medication-category",
            component: AddCategory,
            isDisplay: "no",
          },
          {
            path: "/edit_medication_category",
            layout: "/admin",
            name: "Edit Medication Category",
            mini: "EMC",
            breadcrumb: "Medication Categories",
            breadcrumbPath: "medication-category",
            component: EditCategory,
            isDisplay: "no",
          },
          {
            path: "/edit_medicationTags",
            layout: "/admin",
            name: "Edit Medication Tags",
            mini: "EMT",
            breadcrumb: "Medication Tags",
            breadcrumbPath: "medicationTags",
            component: editMedicationTags,
            isDisplay: "no",
          },
          {
            path: "/add_medicationTags",
            layout: "/admin",
            name: "Add Medication Tags",
            mini: "AMT",
            breadcrumb: "Medication Tags",
            breadcrumbPath: "medicationTags",
            component: addMedicationTags,
            isDisplay: "no",
          },
          {
            path: "/reportlist",
            layout: "/admin",
            name: "Report",
            mini: "RL",
            component: ReportList,
            icon: "fa fa-file-pdf-o",
            isDisplay: "yes",
          },
          {
            path: "/editreport",
            layout: "/admin",
            name: "Edit Report ",
            mini: "ER",
            breadcrumb: "Report",
            breadcrumbPath: "reportlist",
            component: EditReport,
            isDisplay: "no",
          },

          {
            path: "/addreport",
            layout: "/admin",
            name: "Add Report ",
            mini: "AR",
            icon: "fa fa-cubes",
            breadcrumb: "Report",
            breadcrumbPath: "reportlist",
            component: AddReport,
            isDisplay: "no",
          },
          {
            path: "/packagelist",
            layout: "/admin",
            name: "Packages",
            mini: "PL",
            component: Packagelist,
            icon: "fa fa-cubes",
            isDisplay: "yes",
          },
          {
            path: "/editpackage",
            layout: "/admin",
            name: "Edit Package ",
            mini: "EP",
            breadcrumb: "Package",
            breadcrumbPath: "packagelist",
            component: Editpackage,
            isDisplay: "no",
          },

          {
            path: "/addpackage",
            layout: "/admin",
            name: "Add Package ",
            mini: "AP",
            icon: "fa fa-cubes",
            breadcrumb: "Package",
            breadcrumbPath: "packagelist",
            component: Addpackage,
            isDisplay: "no",
          },
          {
            path: "/inventoryList",
            layout: "/admin",
            name: "View Inventory",
            mini: "VM",
            component: InventoryList,
            icon: "fa fa-gear",
            isDisplay: "yes",
          },
          {
            path: "/ProductList",
            layout: "/admin",
            name: "Supplier Product List",
            mini: "PL",
            component: ProductList,
            breadcrumb: "Product List",
            icon: "fa fa-gear",
            isDisplay: "yes",
          },
          {
            path: "/addProductList",
            layout: "/admin",
            name: "Add Product List",
            mini: "AP",
            component: AddProductList,
            isDisplay: "no",
          },
          {
            path: "/inventory",
            layout: "/admin",
            name: "Add Inventory",
            mini: "IM",
            component: InventoryManagement,
            icon: "fa fa-gear",
            isDisplay: "no",
          },
          {
            path: "/editInventory",
            layout: "/admin",
            name: "Edit Inventory",
            mini: "EI",
            component: EditInventoryManagement,
            icon: "fa fa-gear",
            isDisplay: "no",
          },
          // {
          //   path: "/unreceivedGoodsList",
          //   layout: "/admin",
          //   name: "Unreceived Goods",
          //   mini: "VM",
          //   component: UnreceivedGoods,
          //   icon: "fa fa-gear",
          //   isDisplay: "yes",
          // },
          {
            path: "/poList",
            layout: "/admin",
            name: "Purchase Order",
            icon: "fa fa-sliders",
            component: PoList,
            isDisplay: "yes",
          },
          {
            path: "/addPo",
            layout: "/admin",
            name: "Add PO",
            component: AddPo,
            isDisplay: "no",
          },
          {
            path: "/addPoNew",
            layout: "/admin",
            name: "Add-PO",
            component: AddPoNew,
            isDisplay: "no",
          },
          {
            path: "/editPo/:id",
            layout: "/admin",
            name: "Edit PO",
            component: EditPo,
            isDisplay: "no",
            breadcrumb: "PO List",
            breadcrumbPath: "poList",
          },
          {
            path: "/editPoNew/:id",
            layout: "/admin",
            name: "Edit-PO",
            component: EditPoNew,
            isDisplay: "no",
            breadcrumb: "PO List",
            breadcrumbPath: "poList",
          },
          {
            path: "/GoodReturnNote",
            layout: "/admin",
            name: "Good Return Note",
            icon: "fa fa-file",
            component: GoodReturnNote,
            isDisplay: "yes",
          },
        ],
      },
      {
        collapse: true,
        path: "/Claim Manager",
        name: "Claim Manager",
        state: "openNewClaimManager",
        icon: "fa fa-book",
        views: [
          {
            path: "/Claim_Employess_Manager",
            layout: "/admin",
            name: "Employee list",
            mini: "CEM",
            component: claimEmployeeList,
            icon: "fa fa-users",
            isDisplay: "yes",
          },
        ],
      },
      {
        collapse: true,
        path: "/Claims",
        name: "Claims",
        state: "openNewClaims",
        icon: "fa fa-book",
        views: [
          {
            path: "/claim",
            layout: "/admin",
            name: "Claim",
            mini: "CLM",
            component: Claim,
            icon: "fa fa-exchange",
            isDisplay: "yes",
          },
          {
            path: "/Claim-Reconciliation",
            layout: "/admin",
            name: "Claim Reconciliation",
            mini: "CR",
            component: claimReconciliation,
            icon: "fas fa-file-alt",
            isDisplay: "yes",
          },
        ],
      },
      {
        path: "/userManagement",
        layout: "/admin",
        name: "User Management",
        mini: "usr",
        component: userManagement,
        icon: "fa fa-user",
        isDisplay: "yes",
        role: 16,
      },
      {
        path: "/transaction",
        layout: "/admin",
        name: "Transaction",
        mini: "transaction",
        component: transaction,
        icon: "fas fa-dollar-sign",
        isDisplay: "yes",
        role: 16,
      },
      {
        path: "/contact",
        layout: "/admin",
        name: "Contact",
        mini: "usr",
        component: contact,
        icon: "fa fa-phone",
        isDisplay: "yes",
        role: 16,
      },
      {
        path: "/logs",
        layout: "/admin",
        name: "Logs",
        mini: "lgs",
        component: logs,
        icon: "fa fa-history",
        isDisplay: "yes",
        role: 16,
      },
      {
        collapse: true,
        path: "/lead ",
        name: "Product catalogue",
        state: "openProductCatalogue",
        icon: "fa fa-shopping-cart",
        views: [
          {
            path: "/productcatalogue",
            layout: "/admin",
            name: "View Product catalogue",
            mini: "PCV",
            icon: "pe-7s-box1",
            component: ProductCatalogueDeails,
            isDisplay: "yes",
          },
          {
            path: "/addProductCatalogue",
            layout: "/admin",
            name: "Add Product catalogue",
            breadcrumb: "ProductCatalogue",
            breadcrumbPath: "productcatalogue",
            mini: "PCA",
            icon: "pe-7s-note",
            component: ProductCatalogue,
            isDisplay: "no",
          },
          {
            path: "/addProductCatalogueNew",
            layout: "/admin",
            name: "Add Product catalogue",
            breadcrumb: "ProductCatalogue",
            breadcrumbPath: "productcatalogue",
            mini: "PCA",
            icon: "pe-7s-note",
            component: AddProductCatalogueNew,
            isDisplay: "no",
          },

          {
            path: "/editProductCatalogueNew",
            layout: "/admin",
            name: "Edit Product catalogue",
            breadcrumb: "ProductCatalogue",
            breadcrumbPath: "productcatalogue",
            mini: "PCA",
            icon: "pe-7s-note",
            component: EditProductCatalogueNew,
            isDisplay: "no",
          },

          {
            path: "/editProductCatalogue",
            layout: "/admin",
            name: "Edit Product catalogue",
            mini: "PCE",
            breadcrumb: "ProductCatalogue",
            breadcrumbPath: "productcatalogue",
            component: EditProductCatalogue,
            isDisplay: "no",
          },
          {
            path: "/productcatalogue_activity",
            layout: "/admin",
            name: "Catalogue Package Activities",
            icon: "fa fa-tasks",
            component: ProductCatalogueActivity,
            isDisplay: "yes",
          },
          {
            path: "/replicateProductCatalogue",
            layout: "/admin",
            name: "Catalogue Package Replicate",
            icon: "fa fa-tasks",
            component: replicateProductCatalogue,
            isDisplay: "no",
          },
        ],
      },

      {
        path: "/groups",
        layout: "/admin",
        name: "Groups",
        mini: "VG",
        component: ViewGrops,
        icon: "fa fa-gear",
        isDisplay: "yes",
      },
      {
        path: "/addgroup",
        layout: "/admin",
        name: "Add Group",
        mini: "AC",
        component: AddGroup,
        icon: "fa fa-gear",
        isDisplay: "no",
      },
      {
        path: "/edit_group",
        layout: "/admin",
        name: "Edit Group",
        mini: "EC",
        component: EditGroup,
        icon: "fa fa-gear",
        isDisplay: "no",
      },

      {
        path: "/appointments",
        layout: "/admin",
        name: "Appointment",
        mini: "MTS",
        component: ViewAppointment,
        icon: "fa fa-gear",
        isDisplay: "yes",
      },

      {
        collapse: true,
        name: "Coupon & Voucher",
        state: "openvouchermanagement",
        icon: "pe-7s-science",
        views: [
          {
            path: "/coupons",
            layout: "/admin",
            name: "Coupons",
            mini: "VC",
            component: ViewCouponCode,
            icon: "fa fa-gear",
            isDisplay: "yes",
          },
          {
            path: "/addcoupon",
            layout: "/admin",
            name: "Add Coupon Code",
            mini: "AC",
            component: AddCouponCode,
            icon: "fa fa-gear",
            isDisplay: "no",
          },
          {
            path: "/edit_couponcode",
            layout: "/admin",
            name: "Edit Coupon Code",
            mini: "EC",
            component: EditCouponCode,
            icon: "fa fa-gear",
            isDisplay: "no",
          },
          {
            path: "/vouchers",
            layout: "/admin",
            name: "Vouchers",
            mini: "VV",
            component: ViewVoucher,
            icon: "fa fa-gear",
            isDisplay: "yes",
          },
          {
            path: "/addvoucher",
            layout: "/admin",
            name: "Add Voucher",
            mini: "AV",
            component: AddVoucher,
            icon: "fa fa-gear",
            isDisplay: "no",
          },
          {
            path: "/editvoucher",
            layout: "/admin",
            name: "Edit Voucher",
            mini: "EV",
            component: EditVoucher,
            icon: "fa fa-gear",
            isDisplay: "no",
          },
        ],
      },
      {
        path: "/user",
        layout: "/admin",
        name: "Users",
        mini: "UA",
        component: UserList,
        icon: "fa fa-user",
        isDisplay: "yes",
      },
      {
        path: "/country",
        layout: "/admin",
        name: "Country",
        mini: "UA",
        component: Country,
        icon: "fa fa-globe",
        isDisplay: "yes",
      },
      {
        path: "/add-country",
        layout: "/admin",
        name: "Add Country",
        mini: "UA",
        breadcrumb: "Country",
        breadcrumbPath: "country",
        component: AddCountry,
        icon: "fa fa-globe",
        isDisplay: "no",
      },
      {
        path: "/add-user",
        layout: "/admin",
        name: "Add User",
        mini: "UA",
        breadcrumb: "User",
        breadcrumbPath: "user",
        component: AddUser,
        icon: "fa fa-user",
        isDisplay: "no",
      },
      {
        path: "/edit-user",
        layout: "/admin",
        name: "Edit User",
        mini: "UA",
        breadcrumb: "User",
        breadcrumbPath: "user",
        component: EditUser,
        icon: "fa fa-user",
        isDisplay: "no",
      },
      {
        path: "/edit-user-po",
        layout: "/admin",
        name: "Edit User Po",
        mini: "UA",
        breadcrumb: "User",
        breadcrumbPath: "user",
        component: EditUserPo,
        icon: "fa fa-user",
        isDisplay: "no",
      },
      {
        path: "/voucherdonor",
        layout: "/admin",
        name: "Heart 2 Heart",
        mini: "VDLS",
        component: VoucherDonorList,
        icon: "fa fa-heartbeat",
        isDisplay: "yes",
      },
      {
        path: "/addcredit",
        layout: "/admin",
        name: "Flash Credit",
        icon: "fa fa-sliders",
        component: addCredirt,
        isDisplay: "yes",
      },
      {
        path: "/removeflashcredit",
        layout: "/admin",
        name: "Remove Flash Credit",
        icon: "fa fa-trash-o",
        component: removeFlashCredit,
        isDisplay: "yes",
      },
      {
        collapse: true,
        path: "/appContent",
        name: "App Content",
        state: "openAppContent",
        icon: "pe-7s-portfolio",
        views: [
          {
            path: "/deliverytype",
            layout: "/admin",
            name: "View Delivery Types",
            mini: "PCV",
            icon: "pe-7s-box1",
            component: DeliveryTypeDeails,
            isDisplay: "yes",
          },
          {
            path: "/addDeliveryType",
            layout: "/admin",
            name: "Add Delivery Type",
            breadcrumb: "DeliveryType",
            breadcrumbPath: "deliverytype",
            mini: "PCA",
            icon: "pe-7s-note",
            component: DeliveryType,
            isDisplay: "no",
          },

          {
            path: "/editDeliveryType",
            layout: "/admin",
            name: "Edit Delivery Type",
            mini: "PCE",
            breadcrumb: "DeliveryType",
            breadcrumbPath: "deliverytype",
            component: EditDeliveryType,
            isDisplay: "no",
          },
          {
            path: "/healthtopic",
            layout: "/admin",
            name: "Health Topic",
            mini: "HC",
            icon: "fa fa-medkit",
            component: viewhealthtopic,
            isDisplay: "yes",
          },
          {
            path: "/add_healthtopic",
            layout: "/admin",
            name: "Add Health Topic",
            mini: "AHC",
            breadcrumb: "Health Topic",
            breadcrumbPath: "healthtopic",
            component: addhealthtopic,
            isDisplay: "no",
          },
          {
            path: "/edit_healthtopic",
            layout: "/admin",
            name: "Edit Health Topic",
            mini: "EHC",
            breadcrumb: "Health Topic",
            breadcrumbPath: "healthtopic",
            component: edithealthtopic,
            isDisplay: "no",
          },
          {
            path: "/healthcondition",
            layout: "/admin",
            name: "Health Condition",
            mini: "HC",
            icon: "fa fa-medkit",
            component: Viewhealthcondition,
            isDisplay: "yes",
          },
          {
            path: "/add_healthcondition",
            layout: "/admin",
            name: "Add Health Condition",
            mini: "AHC",
            breadcrumb: "Health Condition",
            breadcrumbPath: "healthcondition",
            component: Addhealthcondition,
            isDisplay: "no",
          },
          {
            path: "/edit_healthcondition",
            layout: "/admin",
            name: "Edit Health Condition",
            mini: "EHC",
            breadcrumb: "Health Condition",
            breadcrumbPath: "healthcondition",
            component: Edithealthcondition,
            isDisplay: "no",
          },
        ],
      },

      // {
      //   collapse: true,
      //   path: "/medication",
      //   name: "Medication Management",
      //   state: "openMedictaion",
      //   icon: "pe-7s-portfolio",
      //   views: [
      //     {
      //       path: "/medication",
      //       layout: "/admin",
      //       name: "Medicines",
      //       mini: "MD",
      //       icon: "fa fa-medkit",
      //       component: ViewMedication,
      //       isDisplay: "yes",
      //     },
      //     {
      //       collapse: true,
      //       path: "/medication",
      //       name: "Medicine/Raya Categories",
      //       state: "openRayaCategories",
      //       icon: "fa fa-medkit",
      //       views: [
      //         {
      //           path: "/medication-category",
      //           layout: "/admin",
      //           name: "Categories",
      //           mini: "MCL",
      //           icon: "fa fa-th-large",
      //           component: AllMedicationcategory,
      //           isDisplay: "yes",
      //         },
      //         {
      //           path: "/medicationTags",
      //           layout: "/admin",
      //           name: "Medication Tags (Sub Category)",
      //           mini: "HC",
      //           icon: "fa fa-medkit",
      //           component: viewMedicationTags,
      //           isDisplay: "yes",
      //         },
      //       ],
      //     },
      //     {
      //       path: "/edit_medication",
      //       layout: "/admin",
      //       name: "Edit Medication",
      //       mini: "EM",
      //       breadcrumb: "Medication",
      //       breadcrumbPath: "medication",
      //       component: EditMedication,
      //       isDisplay: "no",
      //     },
      //     {
      //       path: "/addmedication",
      //       layout: "/admin",
      //       name: "Add Medication ",
      //       mini: "AM",
      //       breadcrumb: "Medication",
      //       breadcrumbPath: "medication",
      //       component: AddMedication,
      //       isDisplay: "no",
      //     },

      //     {
      //       path: "/add_medication_category",
      //       layout: "/admin",
      //       name: "Add Medication Category",
      //       mini: "AMC",
      //       breadcrumb: "Medication Categories",
      //       breadcrumbPath: "medication-category",
      //       component: AddCategory,
      //       isDisplay: "no",
      //     },
      //     {
      //       path: "/edit_medication_category",
      //       layout: "/admin",
      //       name: "Edit Medication Category",
      //       mini: "EMC",
      //       breadcrumb: "Medication Categories",
      //       breadcrumbPath: "medication-category",
      //       component: EditCategory,
      //       isDisplay: "no",
      //     },
      //     {
      //       path: "/healthcondition",
      //       layout: "/admin",
      //       name: "Health Condition",
      //       mini: "HC",
      //       icon: "fa fa-medkit",
      //       component: Viewhealthcondition,
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/add_healthcondition",
      //       layout: "/admin",
      //       name: "Add Health Condition",
      //       mini: "AHC",
      //       breadcrumb: "Health Condition",
      //       breadcrumbPath: "healthcondition",
      //       component: Addhealthcondition,
      //       isDisplay: "no",
      //     },
      //     {
      //       path: "/edit_healthcondition",
      //       layout: "/admin",
      //       name: "Edit Health Condition",
      //       mini: "EHC",
      //       breadcrumb: "Health Condition",
      //       breadcrumbPath: "healthcondition",
      //       component: Edithealthcondition,
      //       isDisplay: "no",
      //     },
      //     {
      //       path: "/add_medicationTags",
      //       layout: "/admin",
      //       name: "Add Medication Tags",
      //       mini: "AMT",
      //       breadcrumb: "Medication Tags",
      //       breadcrumbPath: "medicationTags",
      //       component: addMedicationTags,
      //       isDisplay: "no",
      //     },
      //     {
      //       path: "/edit_medicationTags",
      //       layout: "/admin",
      //       name: "Edit Medication Tags",
      //       mini: "EMT",
      //       breadcrumb: "Medication Tags",
      //       breadcrumbPath: "medicationTags",
      //       component: editMedicationTags,
      //       isDisplay: "no",
      //     },

      //     {
      //       path: "/healthtopic",
      //       layout: "/admin",
      //       name: "Health Topic",
      //       mini: "HC",
      //       icon: "fa fa-medkit",
      //       component: viewhealthtopic,
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/add_healthtopic",
      //       layout: "/admin",
      //       name: "Add Health Topic",
      //       mini: "AHC",
      //       breadcrumb: "Health Topic",
      //       breadcrumbPath: "healthtopic",
      //       component: addhealthtopic,
      //       isDisplay: "no",
      //     },
      //     {
      //       path: "/edit_healthtopic",
      //       layout: "/admin",
      //       name: "Edit Health Topic",
      //       mini: "EHC",
      //       breadcrumb: "Health Topic",
      //       breadcrumbPath: "healthtopic",
      //       component: edithealthtopic,
      //       isDisplay: "no",
      //     },
      //     {
      //       path: "/medicationpackages",
      //       layout: "/admin",
      //       name: "Medication Packages",
      //       mini: "MDPV",
      //       icon: "fa fa-medkit",
      //       component: MedicationPackages,
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/addmedicationpackages",
      //       layout: "/admin",
      //       name: "Add Medication Package",
      //       mini: "MDPA",
      //       icon: "fa fa-medkit",
      //       breadcrumb: "Medication Package",
      //       breadcrumbPath: "medicationpackages",
      //       component: AddMedicationPackage,
      //       isDisplay: "no",
      //     },
      //     {
      //       path: "/editmedicationpackages",
      //       layout: "/admin",
      //       name: "Edit Medication Package",
      //       mini: "MDPE",
      //       breadcrumb: "Medication Package",
      //       breadcrumbPath: "medicationpackages",
      //       icon: "fa fa-medkit",
      //       component: EditMedicationPackage,
      //       isDisplay: "no",
      //     },
      //   ],
      // },

      // {
      //   collapse: true,
      //   path: "/Lab",
      //   name: "Lab Management",
      //   state: "openLabmanagement",
      //   icon: "pe-7s-science",
      //   views: [
      //     {
      //       path: "/packagelist",
      //       layout: "/admin",
      //       name: "Packages",
      //       mini: "PL",
      //       component: Packagelist,
      //       icon: "fa fa-cubes",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/editpackage",
      //       layout: "/admin",
      //       name: "Edit Package ",
      //       mini: "EP",
      //       breadcrumb: "Package",
      //       breadcrumbPath: "packagelist",
      //       component: Editpackage,
      //       isDisplay: "no",
      //     },

      //     {
      //       path: "/addpackage",
      //       layout: "/admin",
      //       name: "Add Package ",
      //       mini: "AP",
      //       icon: "fa fa-cubes",
      //       breadcrumb: "Package",
      //       breadcrumbPath: "packagelist",
      //       component: Addpackage,
      //       isDisplay: "no",
      //     },
      //     {
      //       path: "/reportlist",
      //       layout: "/admin",
      //       name: "Report",
      //       mini: "RL",
      //       component: ReportList,
      //       icon: "fa fa-file-pdf-o",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/editreport",
      //       layout: "/admin",
      //       name: "Edit Report ",
      //       mini: "ER",
      //       breadcrumb: "Report",
      //       breadcrumbPath: "reportlist",
      //       component: EditReport,
      //       isDisplay: "no",
      //     },

      //     {
      //       path: "/addreport",
      //       layout: "/admin",
      //       name: "Add Report ",
      //       mini: "AR",
      //       icon: "fa fa-cubes",
      //       breadcrumb: "Report",
      //       breadcrumbPath: "reportlist",
      //       component: AddReport,
      //       isDisplay: "no",
      //     },
      //   ],
      // },

      // {
      //   collapse: true,
      //   path: "/invetorymanagement",
      //   name: "Inventory Management",
      //   state: "openinventorynagement",
      //   icon: "pe-7s-science",
      //   views: [
      //     {
      //       path: "/inventoryList",
      //       layout: "/admin",
      //       name: "View Inventory",
      //       mini: "VM",
      //       component: InventoryList,
      //       icon: "fa fa-gear",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/inventory",
      //       layout: "/admin",
      //       name: "Add Inventory",
      //       mini: "IM",
      //       component: InventoryManagement,
      //       icon: "fa fa-gear",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/editInventory",
      //       layout: "/admin",
      //       name: "Edit Inventory",
      //       mini: "EI",
      //       component: EditInventoryManagement,
      //       icon: "fa fa-gear",
      //       isDisplay: "no",
      //     },
      //     {
      //       path: "/unreceivedGoodsList",
      //       layout: "/admin",
      //       name: "Unreceived Goods",
      //       mini: "VM",
      //       component: UnreceivedGoods,
      //       icon: "fa fa-gear",
      //       isDisplay: "yes",
      //     },
      //   ],
      // },
      // {
      //   collapse: true,
      //   path: "/groupmanagement",
      //   name: "Group Management",
      //   state: "opengroupcodemanagement",
      //   icon: "pe-7s-science",
      //   views: [
      //     {
      //       path: "/groups",
      //       layout: "/admin",
      //       name: "Groups",
      //       mini: "VG",
      //       component: ViewGrops,
      //       icon: "fa fa-gear",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/addgroup",
      //       layout: "/admin",
      //       name: "Add Group",
      //       mini: "AC",
      //       component: AddGroup,
      //       icon: "fa fa-gear",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/edit_group",
      //       layout: "/admin",
      //       name: "Edit Group",
      //       mini: "EC",
      //       component: EditGroup,
      //       icon: "fa fa-gear",
      //       isDisplay: "no",
      //     },
      //   ],
      // },
      // {
      //   collapse: true,
      //   path: "/notificationManagement",
      //   name: "Bulk Notification Management",
      //   state: "opennotficationmanagement",
      //   icon: "pe-7s-science",
      //   views: [
      //     {
      //       path: "/notifications",
      //       layout: "/admin",
      //       name: "Notification Templates",
      //       mini: "VG",
      //       component: ViewNotifications,
      //       icon: "fa fa-gear",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/addnotification",
      //       layout: "/admin",
      //       name: "Add Notification Template",
      //       mini: "AC",
      //       component: AddNotification,
      //       icon: "fa fa-gear",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/edit_notification",
      //       layout: "/admin",
      //       name: "Edit Notification Template",
      //       mini: "EC",
      //       component: EditNotification,
      //       icon: "fa fa-gear",
      //       isDisplay: "no",
      //     },
      //     {
      //       path: "/send_notification",
      //       layout: "/admin",
      //       name: "Send Notification",
      //       mini: "SN",
      //       component: SendBulkNotifictaion,
      //       icon: "fa fa-gear",
      //       isDisplay: "yes",
      //     },
      //   ],
      // },
      // {
      //   collapse: true,
      //   path: "/couponcodemanagement",
      //   name: "Coupon Management",
      //   state: "opencouponcodemanagement",
      //   icon: "pe-7s-science",
      //   views: [
      //     {
      //       path: "/coupons",
      //       layout: "/admin",
      //       name: "Coupons",
      //       mini: "VC",
      //       component: ViewCouponCode,
      //       icon: "fa fa-gear",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/addcoupon",
      //       layout: "/admin",
      //       name: "Add Coupon Code",
      //       mini: "AC",
      //       component: AddCouponCode,
      //       icon: "fa fa-gear",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/edit_couponcode",
      //       layout: "/admin",
      //       name: "Edit Coupon Code",
      //       mini: "EC",
      //       component: EditCouponCode,
      //       icon: "fa fa-gear",
      //       isDisplay: "no",
      //     },
      //   ],
      // },
      // {
      //   collapse: true,
      //   name: "Voucher Management",
      //   state: "openvouchermanagement",
      //   icon: "pe-7s-science",
      //   views: [
      //     {
      //       path: "/vouchers",
      //       layout: "/admin",
      //       name: "Vouchers",
      //       mini: "VV",
      //       component: ViewVoucher,
      //       icon: "fa fa-gear",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/addvoucher",
      //       layout: "/admin",
      //       name: "Add Voucher",
      //       mini: "AV",
      //       component: AddVoucher,
      //       icon: "fa fa-gear",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/editvoucher",
      //       layout: "/admin",
      //       name: "Edit Voucher",
      //       mini: "EV",
      //       component: EditVoucher,
      //       icon: "fa fa-gear",
      //       isDisplay: "no",
      //     },
      //   ],
      // },
      {
        collapse: true,
        path: "/subscriptionmanagement",
        name: "Subscription Management",
        state: "opendubdcriptionmanagement",
        icon: "pe-7s-science",
        views: [
          {
            path: "/subscription",
            layout: "/admin",
            name: "Subscriptions Package",
            mini: "Sc",
            component: ViewSubcription,
            icon: "fa fa-cubes",
            isDisplay: "yes",
          },
          {
            path: "/edit_subscription",
            layout: "/admin",
            name: "Edit Subscription Package",
            mini: "Es",
            breadcrumb: "Subscription Package",
            breadcrumbPath: "subscription package",
            component: EditSubcription,
            isDisplay: "no",
          },
          {
            path: "/addsubscription",
            layout: "/admin",
            name: "Add Subscription Package",
            mini: "Sc",
            icon: "fa fa-cubes",
            breadcrumb: "Subscription Package",
            breadcrumbPath: "subscription package",
            component: Subcription,
            isDisplay: "no",
          },
          {
            path: "/subscriptionpackage",
            layout: "/admin",
            name: "Subscription products",
            mini: "Sc",
            component: viewSubscriptionpackage,
            icon: "fa fa-cubes",
            isDisplay: "yes",
          },
          {
            path: "/editsubscriptionpackage",
            layout: "/admin",
            name: "Edit Subscription Products ",
            mini: "Es",
            breadcrumb: "Subscription Products",
            breadcrumbPath: "subscription Products",
            component: editsubscriptionpackage,
            isDisplay: "no",
          },
          {
            path: "/addsubscriptionpackage",
            layout: "/admin",
            name: "Add Subscription Products",
            mini: "Sc",
            icon: "fa fa-cubes",
            breadcrumb: "Subscription Products",
            breadcrumbPath: "subscription Products",
            component: addnewsubscriptionpackage,
            isDisplay: "no",
          },
        ],
      },
      // {
      //   collapse: true,
      //   path: "/specialitymanagement",
      //   name: "Speciality Management",
      //   state: "openspecialitymanagement",
      //   icon: "pe-7s-science",
      //   views: [
      //     {
      //       path: "/speciality",
      //       layout: "/admin",
      //       name: "Groups",
      //       name: "Specialities",
      //       mini: "MVS",
      //       component: ViewSpeciality,
      //       icon: "fa fa-gear",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/addspeciality",
      //       layout: "/admin",
      //       name: "Add Speciality",
      //       mini: "MAS",
      //       component: AddSpeciality,
      //       icon: "fa fa-gear",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/editspeciality",
      //       layout: "/admin",
      //       name: "Edit Speciality",
      //       mini: "MES",
      //       component: EditSpeciality,
      //       icon: "fa fa-gear",
      //       isDisplay: "no",
      //     },
      //   ],
      // },
      // {
      //   collapse: true,
      //   name: "Schedule Management",
      //   state: "openschedulemanagement",
      //   icon: "pe-7s-science",
      //   views: [
      //     {
      //       collapse: true,
      //       name: "Global Schedule",
      //       state: "openglobalschedulemanagement",
      //       icon: "pe-7s-science",
      //       views: [
      //         {
      //           path: "/globalschedule",
      //           layout: "/admin",
      //           name: "Global Schedules",
      //           mini: "GSL",
      //           component: ListGlobal,
      //           icon: "fa fa-gear",
      //           isDisplay: "yes",
      //         },
      //         {
      //           path: "/addglobalschedule",
      //           layout: "/admin",
      //           name: "Add Global Schedule",
      //           mini: "GSA",
      //           component: AddGlobal,
      //           icon: "fa fa-gear",
      //           isDisplay: "yes",
      //         },
      //         {
      //           path: "/editglobalschedule",
      //           layout: "/admin",
      //           name: "Edit Global Schedule",
      //           mini: "GSE",
      //           component: EditGlobal,
      //           icon: "fa fa-gear",
      //           isDisplay: "no",
      //         },
      //       ],
      //     },

      //     {
      //       path: "/doctor_schedules",
      //       layout: "/admin",
      //       name: "Doctor Schedule",
      //       mini: "MTS",
      //       component: ViewSlot,
      //       icon: "pe-7s-science",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/editschedule",
      //       layout: "/admin",
      //       name: "Edit Schedule",
      //       mini: "MSE",
      //       component: EditSlot,
      //       icon: "fa fa-gear",
      //       isDisplay: "no",
      //     },
      //   ],
      // },
      // {
      //   path: "/appointments",
      //   layout: "/admin",
      //   name: "Appointment",
      //   mini: "MTS",
      //   component: ViewAppointment,
      //   icon: "fa fa-gear",
      //   isDisplay: "yes",
      // },
      {
        path: "/setting",
        layout: "/admin",
        name: "Settings",
        mini: "Sc",
        component: Settingdetails,
        icon: "fa fa-gear",
        isDisplay: "yes",
      },
      {
        path: "/edit_commision",
        layout: "/admin",
        name: "Settings",
        mini: "Sc",
        component: EditCommision,
        icon: "fa fa-gear",
        isDisplay: "no",
      },
      {
        path: "/edit_setting",
        layout: "/admin",
        name: "Settings",
        mini: "Sc",
        component: EditSetting,
        icon: "fa fa-gear",
        isDisplay: "no",
      },

      // {
      //   collapse: true,
      //   path: "/Bulkimport",
      //   name: "Bulk Import",
      //   state: "openbulkimport",
      //   icon: "pe-7s-albums",
      //   views: [
      //     {
      //       path: "/order-import",
      //       layout: "/admin",
      //       name: "Medicine Order",
      //       mini: "BA",
      //       component: BulkImport,
      //       icon: "fa fa-align-justify",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/lab-order-import",
      //       layout: "/admin",
      //       name: "Lab Order",
      //       mini: "BA",
      //       component: LabOrderImport,
      //       icon: "fa fa-align-justify",
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/customer-import",
      //       layout: "/admin",
      //       name: "Leads",
      //       mini: "BA",
      //       component: LeadImport,
      //       icon: "fa fa-align-justify",
      //       isDisplay: "yes",
      //     },
      //   ],
      // },
      // {
      //   path: "/user",
      //   layout: "/admin",
      //   name: "Users",
      //   mini: "UA",
      //   component: UserList,
      //   icon: "fa fa-user",
      //   isDisplay: "yes",
      // },
      // {
      //   collapse: true,
      //   layout: "/admin",
      //   state: "openRiderTracking",
      //   name: "Rider Tracking",
      //   icon: "fa fa-user",
      //   views: [
      //     {
      //       collapse: true,
      //       layout: "/admin",
      //       state: "openRiders",
      //       name: "Riders",
      //       icon: "fa fa-user",
      //       views: [
      //         {
      //           path: "/riderlocation",
      //           layout: "/admin",
      //           name: "Rider Location",
      //           mini: "RLV",
      //           component: RiderLocation,
      //           icon: "fa fa-align-justify",
      //           isDisplay: "yes",
      //         },
      //         {
      //           path: "/riderdistace",
      //           layout: "/admin",
      //           name: "Rider Distance",
      //           mini: "RDV",
      //           component: RiderDistance,
      //           icon: "fa fa-align-justify",
      //           isDisplay: "yes",
      //         },
      //       ],
      //     },
      //     {
      //       path: "/labrider",
      //       layout: "/admin",
      //       name: "Lab Riders",
      //       mini: "LR",
      //       component: labridertracker,
      //       icon: "fa fa-user",
      //       isDisplay: "yes",
      //     },
      //   ],
      // },
    ],
  },
  {
    collapse: true,
    path: "/bulk-action",
    name: "Bulk Action",
    state: "openNewBulkAction",
    icon: "fa fa-upload",
    views: [
      {
        path: "/medication-import",
        layout: "/admin",
        name: "Medicine",
        mini: "BA",
        component: MedicineImport,
        icon: "fa fa-medkit",
        isDisplay: "yes",
      },
      {
        path: "/order-import",
        layout: "/admin",
        name: "Medicine Order",
        mini: "BA",
        component: BulkImport,
        icon: "fa fa-align-justify",
        isDisplay: "yes",
      },
      {
        path: "/lab-order-import",
        layout: "/admin",
        name: "Lab Order",
        mini: "BA",
        component: LabOrderImport,
        icon: "fa fa-align-justify",
        isDisplay: "yes",
      },
      {
        path: "/customer-import",
        layout: "/admin",
        name: "Leads",
        mini: "BA",
        component: LeadImport,
        icon: "fa fa-align-justify",
        isDisplay: "yes",
      },
      {
        path: "/Leads-Assign-import",
        layout: "/admin",
        name: "Leads Assign",
        mini: "FB",
        component: leadsBulkUpload,
        icon: "fa fa-align-justify",
        isDisplay: "yes",
      },
      {
        path: "/Family-Bulk-import",
        layout: "/admin",
        name: "Family Bulk",
        mini: "FB",
        component: FamilyBulkImport,
        icon: "fa fa-align-justify",
        isDisplay: "yes",
      },
      {
        path: "/notifications",
        layout: "/admin",
        name: "Notification Templates",
        mini: "VG",
        component: ViewNotifications,
        icon: "fa fa-gear",
        isDisplay: "yes",
      },
      {
        path: "/addnotification",
        layout: "/admin",
        name: "Add Notification Template",
        mini: "AC",
        component: AddNotification,
        icon: "fa fa-gear",
        isDisplay: "no",
      },
      {
        path: "/edit_notification",
        layout: "/admin",
        name: "Edit Notification Template",
        mini: "EC",
        component: EditNotification,
        icon: "fa fa-gear",
        isDisplay: "no",
      },
      {
        path: "/send_notification",
        layout: "/admin",
        name: "Send Notification",
        mini: "SN",
        component: SendBulkNotifictaion,
        icon: "fa fa-gear",
        isDisplay: "yes",
      },
      {
        path: "/doctor-payouts",
        layout: "/admin",
        name: "Doctor Payout",
        mini: "SN",
        component: DoctorPayOuts,
        icon: "fa fa-money",
        isDisplay: "yes",
      },
      {
        path: "/Team-Bulk-import",
        layout: "/admin",
        name: "Team Bulk",
        mini: "FB",
        component: TeamBulkImport,
        icon: "fa fa-align-justify",
        isDisplay: "yes",
      },
    ],
  },
  {
    collapse: true,
    path: "/external",
    name: "External",
    state: "openNewexternal",
    icon: "fa fa-external-link",
    views: [
      {
        path: "/xero_invoice",
        layout: "/admin",
        name: "Xero Invoice",
        mini: "DLS",
        component: XeroInvoice,
        icon: "fa fa-file",
        isDisplay: "yes",
      },
    ],
  },
  {
    collapse: true,
    path: "/Package Summary",
    name: "Package Summary",
    state: "openNewUtil",
    icon: "fa fa-wrench",
    views: [
      {
        path: "/product_utility",
        layout: "/admin",
        name: "Order Utilization",
        mini: "PUL",
        component: ProductUtility,
        icon: "fas fa-stopwatch",
        isDisplay: "yes",
      },
      {
        path: "/product_consultation",
        layout: "/admin",
        name: "Consult Utilization",
        mini: "PC",
        component: Productconsultation,
        icon: "fas fa-user-md",
        isDisplay: "yes",
      },
    ],
  },
  {
    collapse: true,
    path: "/Warehouse",
    name: "Inventory Request",
    state: "Warehouse",
    icon: "fas fa-landmark",
    views: [
      {
        path: "/purchase-request",
        layout: "/admin",
        name: "Stock Refill Requests",
        mini: "CLM",
        component: MedicineWiseOrder,
        icon: "fa fa-refresh",
        isDisplay: "yes",
        role: 18,
      },
      // {
      //   path: "/authorization-level",
      //   layout: "/admin",
      //   name: "Pending-Authorization",
      //   mini: "AL",
      //   icon: "fas fa-user-shield",
      //   component: AuthorizationLevel,
      //   isDisplay: "yes",
      // },
      {
        path: "/AddPurchaseRequestForm",
        layout: "/admin",
        name: "Add-Refill-Request",
        component: AddPurchaseRequestForm,
        isDisplay: "no",
        mini: "APR",
        breadcrumb: "Refill-request",
        breadcrumbPath: "Refill-request",
      },
      {
        path: "/EditPurchaseRequest",
        layout: "/admin",
        name: "Edit-Refill-Request",
        component: EditPurchaseRequest,
        isDisplay: "no",
        mini: "EPR",
        breadcrumb: "Refill-request",
        breadcrumbPath: "/admin/Refil-request",
      },
      {
        path: "/warehouse-inventory-dispatch",
        layout: "/admin",
        name: "Warehouse Inventory Dispatch",
        mini: "LD",
        icon: "pe-7s-ball",
        component: WarehouseInventoryDispatch,
        isDisplay: "yes",
      },
      {
        path: "/add-warehouse-inventory-dispatch",
        layout: "/admin",
        name: "Add Warehouse Inventory Dispatch",
        breadcrumb: "Warehouse Inventory Dispatch",
        breadcrumbPath: "/admin/warehouse-inventory-dispatch",
        mini: "LE",
        icon: "pe-7s-note",
        component: AddWarehouseInventoryDispatch,
        isDisplay: "no",
      },

      {
        path: "/edit-warehouse-inventory-dispatch/:id",
        layout: "/admin",
        name: "Edit Warehouse Inventory Dispatch",
        breadcrumb: "Warehouse Inventory Dispatch",
        breadcrumbPath: "/admin/warehouse-inventory-dispatch",
        mini: "LE",
        icon: "pe-7s-note",
        component: EditWarehouseInventoryDispatch,
        isDisplay: "no",
      },
      {
        path: "/getRelatedStore",
        layout: "/admin",
        name: "Inventory",
        mini: "GRS",
        icon: "fas fa-capsules",
        component: getRelatedStore,
        isDisplay: "yes",
        role: 18,
      },
      {
        path: "/Good-Return-Note-Bulk-Upload",
        layout: "/admin",
        name: "Good Return Note",
        mini: "GRS",
        icon: "fa fa-retweet",
        component: returnNoteBulkUpload,
        isDisplay: "yes",
        role: 18,
      },
      {
        path: "/medication",
        layout: "/admin",
        name: "Medicines",
        mini: "MD",
        icon: "fa fa-medkit",
        component: ViewMedication,
        isDisplay: "yes",
      },
    ],
  },

  {
    collapse: true,
    path: "/logs",
    name: "Logs",
    state: "openNewLogs",
    icon: "fa fa-history",
    views: [
      {
        path: "/user_log",
        layout: "/admin",
        name: "Admin Log",
        mini: "PCVL",
        icon: "fa fa-tasks",
        component: UserLog,
        isDisplay: "yes",
      },
      {
        path: "/activitydetails",
        layout: "/admin",
        name: "App Log",
        mini: "PCAX",
        icon: "fa fa-tasks",
        component: activityDetails,
        isDisplay: "yes",
      },
      {
        collapse: true,
        layout: "/admin",
        state: "openRiders",
        name: "Riders",
        icon: "fa fa-user",
        views: [
          {
            path: "/riderlocation",
            layout: "/admin",
            name: "Rider Location",
            mini: "RLV",
            component: RiderLocation,
            icon: "fa fa-align-justify",
            isDisplay: "yes",
          },
          {
            path: "/old-riderlocation",
            layout: "/admin",
            name: "Rider Location (Old)",
            mini: "RLVO",
            component: RiderLocationOld,
            icon: "fa fa-align-justify",
            isDisplay: "yes",
          },
          {
            path: "/riderdistace",
            layout: "/admin",
            name: "Rider Distance",
            mini: "RDV",
            component: RiderDistance,
            icon: "fa fa-align-justify",
            isDisplay: "yes",
          },
          {
            path: "/old-riderdistace",
            layout: "/admin",
            name: "Rider Distance (Old)",
            mini: "RDVO",
            component: RiderDistanceOld,
            icon: "fa fa-align-justify",
            isDisplay: "yes",
          },
          {
            path: "/labrider",
            layout: "/admin",
            name: "Lab Riders",
            mini: "LR",
            component: labridertracker,
            icon: "fa fa-user",
            isDisplay: "yes",
          },
        ],
      },
    ],
  },
  {
    collapse: true,
    name: "Other Features",
    state: "openOtherFeatures",
    icon: "fa fa-sliders",
    views: [
      // {
      //   collapse: true,
      //   path: "/lead ",
      //   name: "Product catalogue",
      //   state: "openProductCatalogue",
      //   icon: "fa fa-shopping-cart",
      //   views: [
      //     {
      //       path: "/productcatalogue",
      //       layout: "/admin",
      //       name: "View Product catalogue",
      //       mini: "PCV",
      //       icon: "pe-7s-box1",
      //       component: ProductCatalogueDeails,
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/addProductCatalogue",
      //       layout: "/admin",
      //       name: "Add Product catalogue",
      //       breadcrumb: "ProductCatalogue",
      //       breadcrumbPath: "productcatalogue",
      //       mini: "PCA",
      //       icon: "pe-7s-note",
      //       component: ProductCatalogue,
      //       isDisplay: "yes",
      //     },

      //     {
      //       path: "/editProductCatalogue",
      //       layout: "/admin",
      //       name: "Edit Product catalogue",
      //       mini: "PCE",
      //       breadcrumb: "ProductCatalogue",
      //       breadcrumbPath: "productcatalogue",
      //       component: EditProductCatalogue,
      //       isDisplay: "no",
      //     },
      //     {
      //       path: "/productcatalogue_activity",
      //       layout: "/admin",
      //       name: "Catalogue Package Activities",
      //       icon: "fa fa-tasks",
      //       component: ProductCatalogueActivity,
      //       isDisplay: "yes",
      //     },
      //   ],
      // },
      {
        path: "/useCoupon",
        layout: "/admin",
        name: "Redeem Coupon",
        mini: "UC",
        component: UseCouponCode,
        icon: "fa fa-gear",
        isDisplay: "yes",
      },

      // {
      //   path: "/voucherdonor",
      //   layout: "/admin",
      //   name: "Voucher Donor ",
      //   mini: "VDLS",
      //   component: VoucherDonorList,
      //   icon: "fa fa-heartbeat",
      //   isDisplay: "yes",
      // },
      // {
      //   path: "/xero_invoice",
      //   layout: "/admin",
      //   name: "Xero Invoice",
      //   mini: "DLS",
      //   component: XeroInvoice,
      //   icon: "fa fa-file",
      //   isDisplay: "yes",
      // },
      // {
      //   path: "/addcredit",
      //   layout: "/admin",
      //   name: "Add Credit",
      //   icon: "fa fa-sliders",
      //   component: addCredirt,
      //   isDisplay: "yes",
      // },
      // {
      //   collapse: true,
      //   name: "Activity Log",
      //   state: "openActivityLog",
      //   icon: "fa fa-sliders",
      //   views: [
      //     {
      //       path: "/user_log",
      //       layout: "/admin",
      //       name: "Admin Log",
      //       mini: "PCVL",
      //       icon: "fa fa-tasks",
      //       component: UserLog,
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/activitydetails",
      //       layout: "/admin",
      //       name: "App Log",
      //       mini: "PCAX",
      //       icon: "fa fa-tasks",
      //       component: activityDetails,
      //       isDisplay: "yes",
      //     },
      //   ],
      // },
      // {
      //   collapse: true,
      //   path: "/deliverytype ",
      //   name: "Delivery Type",
      //   state: "openDeliveryTypes",
      //   icon: "fa fa-truck",
      //   views: [
      //     {
      //       path: "/deliverytype",
      //       layout: "/admin",
      //       name: "View Delivery Types",
      //       mini: "PCV",
      //       icon: "pe-7s-box1",
      //       component: DeliveryTypeDeails,
      //       isDisplay: "yes",
      //     },
      //     {
      //       path: "/addDeliveryType",
      //       layout: "/admin",
      //       name: "Add Delivery Type",
      //       breadcrumb: "DeliveryType",
      //       breadcrumbPath: "deliverytype",
      //       mini: "PCA",
      //       icon: "pe-7s-note",
      //       component: DeliveryType,
      //       isDisplay: "yes",
      //     },

      //     {
      //       path: "/editDeliveryType",
      //       layout: "/admin",
      //       name: "Edit Delivery Type",
      //       mini: "PCE",
      //       breadcrumb: "DeliveryType",
      //       breadcrumbPath: "deliverytype",
      //       component: EditDeliveryType,
      //       isDisplay: "no",
      //     },
      //   ],
      // },
      // {
      //   path: "/poList",
      //   layout: "/admin",
      //   name: "PO List",
      //   icon: "fa fa-sliders",
      //   component: PoList,
      //   isDisplay: "yes",
      // },
      // {
      //   path: "/addPo",
      //   layout: "/admin",
      //   name: "Add PO",
      //   component: AddPo,
      //   isDisplay: "no",
      // },
      // {
      //   path: "/editPo/:id",
      //   layout: "/admin",
      //   name: "Edit PO",
      //   component: EditPo,
      //   isDisplay: "no",
      //   breadcrumb: "PO List",
      //   breadcrumbPath: "poList",
      // },
    ],
  },
  {
    collapse: true,
    path: "/helpdesk",
    name: "IT Help Desk",
    state: "openHelpdesk",
    icon: "fas fa-headset",
    views: [
      {
        path: "/tickets",
        layout: "/admin",
        name: "Tickets",
        mini: "VTL",
        component: ViewTickets,
        icon: "fa fa-gear",
        isDisplay: "yes",
      },
      {
        path: "/addticket",
        layout: "/admin",
        name: "Add Ticket",
        mini: "ANT",
        component: AddTicket,
        icon: "fa fa-gear",
        isDisplay: "yes",
      },
      {
        path: "/editticket",
        layout: "/admin",
        name: "Edit Ticket",
        mini: "ANT",
        component: EditTicket,
        icon: "fa fa-gear",
        isDisplay: "no",
      },
    ],
  },
  {
    collapse: true,
    path: "/lighthouse",
    name: "Light House",
    state: "openLightHouse",
    icon: "fa fa-home",
    views: [
      {
        path: "/lightHouse-category",
        layout: "/admin",
        name: "Light House Category",
        mini: "ANT",
        component: ViewLightHouseCategory,
        icon: "fa fa-list-alt",
        isDisplay: "yes",
      },
      {
        path: "/lightHouse-template",
        layout: "/admin",
        name: "Light House Template",
        mini: "ANT",
        component: ViewLightHouseTemplate,
        icon: "fa fa-list-alt",
        isDisplay: "yes",
      },

      {
        path: "/lightHouse-sub-category",
        layout: "/admin",
        name: "Light House Sub Category",
        mini: "ANT",
        component: ViewLightHouseSubCategories,
        icon: "fa fa-list-alt",
        isDisplay: "yes",
      },
    ],
  },
  {
    collapse: true,
    path: "/reports ",
    name: "Reports",
    state: "openReport",
    icon: "pe-7s-note2",
    views: [
      {
        path: "/claim_report",
        layout: "/admin",
        name: "Claim Report ",
        breadcrumb: "Claim Report",
        breadcrumbPath: "Claim_report",
        mini: "OR",
        icon: "fa fa-clone",
        component: ClaimReport,
        isDisplay: "yes",
      },
    ],
  },
  {
    path: "/banner-notice-list",
    layout: "/admin",
    name: " Banner Notice List",
    mini: "LD",
    icon: "fa fa-comment",
    component: BannerList,
    isDisplay: "yes",
  },
  {
    path: "/add-banner-notice-list",
    layout: "/admin",
    name: "Add Banner Notice List",
    breadcrumb: "Banner Notice List",
    breadcrumbPath: "/admin/banner-notice-list",
    mini: "LE",
    icon: "pe-7s-note",
    component: AddBannerNotice,
    isDisplay: "no",
  },

  {
    path: "/edit-banner-notice-list",
    layout: "/admin",
    name: "Edit Banner Notice List",
    breadcrumb: "Banner Notice List",
    breadcrumbPath: "/admin/banner-notice-list",
    mini: "LE",
    icon: "pe-7s-note",
    component: EditBannerNotice,
    isDisplay: "no",
  },
  // ],
  // },

  {
    path: "/calculator",
    layout: "/add-warehouse-inventory-dispatchmin",
    name: "Savings Calculator",
    icon: "fa fa-calculator",
    component: SavingsCalculator,
    isDisplay: "yes",
  },
  /*{
    path: "/donors",
    layout: "/admin",
    name: "Donor ",
    mini: "DLS",
    component: DonorList,
    icon: "fa fa-heartbeat",
    isDisplay: "yes",
  },*/
  // {
  //   path: "/addvcrdonor",
  //   layout: "/admin",
  //   name: "Add Voucher Donor",
  //   mini: "VDAN",
  //   component: AddDonorVoucher,
  //   icon: "fa fa-heartbeat",
  //   isDisplay: "no",
  // },
  //fa fa-hospital-o
  // {
  // collapse: true,
  // path: "/sucscription ",
  // name: "Subscription",
  // state: "opensubscription",
  // icon: "fa fa-cubes",
  // views: [
  //   {
  //     path:'/addsubscription',
  //     layout :'/admin',
  //     name: "Subscription ",
  //     mini: "Sc",
  //     icon: "fa fa-cubes",
  //     component : Subcription,
  //     isDisplay:"no"
  //   },
  //   {
  //     path:'/subscription',
  //     layout :'/admin',
  //     name: "Subscription Details",
  //     mini: "Sc",
  //     component : ViewSubcription,
  //     isDisplay:"yes"
  //   },
  //   {
  //     path:'/edit_subscription',
  //     layout :'/admin',
  //     name: "Edit Subscription ",
  //     mini: "Es",
  //     component : EditSubcription,
  //     isDisplay:"no"
  //   },

  // ]
  // },
  // {
  //   collapse: true,
  //   path: "/components",
  //   name: "Components",
  //   state: "openComponents",
  //   icon: "pe-7s-plugin",
  //   views: [
  //     {
  //       path: "/buttons",
  //       layout: "/admin",
  //       name: "Buttons",
  //       mini: "B",
  //       component: Buttons,
  //       isDisplay:"yes"
  //     },
  //     {
  //       path: "/grid-system",
  //       layout: "/admin",
  //       name: "Grid System",
  //       mini: "GS",
  //       component: GridSystem,
  //       isDisplay:"yes"
  //     },
  //     {
  //       path: "/panels",
  //       layout: "/admin",
  //       name: "Panels",
  //       mini: "P",
  //       component: Panels,
  //       isDisplay:"yes"
  //     },
  //     {
  //       path: "/sweet-alert",
  //       layout: "/admin",
  //       name: "Sweet Alert",
  //       mini: "SA",
  //       component: SweetAlert,
  //       isDisplay:"yes"
  //     },
  //     {
  //       path: "/notifications",
  //       layout: "/admin",
  //       name: "Notifications",
  //       mini: "N",
  //       component: Notifications,
  //       isDisplay:"yes"
  //     },
  //     {
  //       path: "/icons",
  //       layout: "/admin",
  //       name: "Icons",
  //       mini: "I",
  //       component: Icons,
  //       isDisplay:"yes"
  //     },
  //     {
  //       path: "/typography",
  //       layout: "/admin",
  //       name: "Typography",
  //       mini: "T",
  //       component: Typography,
  //       isDisplay:"yes"
  //     }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/forms",
  //   name: "Forms",
  //   state: "openForms",
  //   icon: "pe-7s-note2",
  //   views: [
  //     {
  //       path: "/regular-forms",
  //       layout: "/admin",
  //       name: "Regular Forms",
  //       mini: "RF",
  //       isDisplay:"yes",
  //       component: RegularForms
  //     },
  //     {
  //       path: "/extended-forms",
  //       layout: "/admin",
  //       name: "Extended Forms",
  //       mini: "EF",
  //       isDisplay:"yes",
  //       component: ExtendedForms
  //     },

  //     {
  //       path: "/validation-forms",
  //       layout: "/admin",
  //       name: "Validation Forms",
  //       mini: "VF",
  //       isDisplay:"yes",

  //       component: ValidationForms
  //     },
  //     {
  //       path: "/wizard",
  //       layout: "/admin",
  //       name: "Wizard",
  //       mini: "W",
  //       isDisplay:"yes",

  //       component: Wizard
  //     }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/tables",
  //   name: "Tables",
  //   state: "openTables",
  //   icon: "pe-7s-news-paper",
  //   views: [
  //     {
  //       path: "/regular-tables",
  //       layout: "/admin",
  //       name: "Regular Tables",
  //       mini: "RT",
  //       component: RegularTables,
  //       isDisplay : "yes"
  //     },

  //     {
  //       path: "/extended-tables",
  //       layout: "/admin",
  //       name: "Extended Tables",
  //       mini: "ET",
  //       component: ExtendedTables,
  //       isDisplay : "yes"
  //     },
  //     {
  //       path: "/react-table",
  //       layout: "/admin",
  //       name: "React Table",
  //       mini: "RT",
  //       component: ReactTables,
  //       isDisplay : "yes"
  //     }
  //   ]
  // },
  // {
  //   collapse: true,
  //   path: "/maps",
  //   name: "Maps",
  //   state: "openMaps",
  //   icon: "pe-7s-map-marker",
  //   views: [
  //     {
  //       path: "/google-maps",
  //       layout: "/admin",
  //       name: "Google Maps",
  //       mini: "GM",
  //       component: GoogleMaps
  //     },
  //     {
  //       path: "/full-screen-maps",
  //       layout: "/admin",
  //       name: "Full Screen Map",
  //       mini: "FSM",
  //       component: FullScreenMap
  //     },
  //     {
  //       path: "/vector-maps",
  //       layout: "/admin",
  //       name: "Vector Map",
  //       mini: "VM",
  //       component: VectorMap
  //     }
  //   ]
  // },
  // {
  //   path: "/charts",
  //   layout: "/admin",
  //   name: "Charts",
  //   icon: "pe-7s-graph1",
  //   component: Charts
  // },
  // {
  //   path: "/calendar",
  //   layout: "/admin",
  //   name: "Calendar",
  //   icon: "pe-7s-date",
  //   component: Calendar
  // },
  // {
  //   collapse: true,
  //   path: "/pages",
  //   name: "Pages",
  //   state: "openPages",
  //   icon: "pe-7s-gift",
  //   views: [
  //     {
  //       path: "/user-page",
  //       layout: "/admin",
  //       name: "User Page",
  //       mini: "UP",
  //       component: UserPage
  //     },
  //     {
  //       path: "/login-page",
  //       layout: "/auth",
  //       name: "Login Page",
  //       mini: "LP",
  //       component: LoginPage
  //     },
  //     {
  //       path: "/register-page",
  //       layout: "/auth",
  //       name: "Register",
  //       mini: "RP",
  //       component: RegisterPage
  //     },
  //     {
  //       path: "/lock-screen-page",
  //       layout: "/auth",
  //       name: "Lock Screen Page"
  //       mini: "LSP",
  //       component: LockScreenPage
  //     }
  //   ]
  // },

  // {
  //   collapse: true,
  //   path: "/featured ",
  //   name: "New Menu",
  //   state: "openFeatured",
  //   icon: "fa fa-user-plus",
  //   views: [
  //     {
  //       collapse: true,
  //       path: "/order ",
  //       name: "Orders",
  //       // state: "openOrder",
  //       icon: "pe-7s-note2",
  //       views: [
  //         {
  //           collapse: true,
  //           path: "/order ",
  //           name: "Medicine",
  //           state: "openmedicine",
  //           icon: "pe-7s-note2",
  //           views: [
  //             {
  //               path: "/add-order/:id",
  //               layout: "/admin",
  //               name: "New Order ",
  //               breadcrumb: "All Orders",
  //               breadcrumbPath: "order_list",
  //               mini: "OR",
  //               icon: "fa fa-clone",
  //               component: Order,
  //               isDisplay: "no",
  //             },
  //             {
  //               path: "/add-order",
  //               layout: "/admin",
  //               name: "New Order ",
  //               breadcrumb: "All Orders",
  //               breadcrumbPath: "order_list",
  //               mini: "OR",
  //               icon: "fa fa-clone",
  //               component: Order,
  //               isDisplay: "yes",
  //             },
  //             {
  //               path: "/order_list",
  //               layout: "/admin",
  //               name: "Order List",
  //               mini: "OD",
  //               icon: "pe-7s-news-paper",
  //               component: OrderList,
  //               isDisplay: "yes",
  //             },
  //             {
  //               path: "/upcoming_order",
  //               layout: "/admin",
  //               name: "Upcoming Orders",
  //               mini: "OU",
  //               icon: "pe-7s-news-paper",
  //               component: UpcomingOrder,
  //               isDisplay: "yes",
  //             },

  //             {
  //               path: "/order/:id",
  //               layout: "/admin",
  //               name: "Edit Order",
  //               mini: "ER",
  //               breadcrumb: "All Orders",
  //               breadcrumbPath: "order_list",
  //               icon: "pe-7s-news-paper",
  //               component: EditOrder,
  //               isDisplay: "no",
  //             },
  //           ],
  //         },
  //         {
  //           collapse: true,
  //           path: "/order ",
  //           name: "Lab",
  //           state: "openorderlab",
  //           icon: "pe-7s-note2",
  //           views: [
  //             {
  //               path: "/lab-add-order/:id",
  //               layout: "/admin",
  //               name: "New Lab Order ",
  //               breadcrumb: "Lab OrderList",
  //               breadcrumbPath: "lab_order_list",
  //               mini: "OR",
  //               icon: "fa fa-clone",
  //               component: AddLabOrder,
  //               isDisplay: "no",
  //             },

  //             {
  //               path: "/lab-add-order",
  //               layout: "/admin",
  //               name: "New Lab Order ",
  //               breadcrumb: "Lab OrderList",
  //               breadcrumbPath: "lab_order_list",
  //               mini: "OR",
  //               icon: "fa fa-clone",
  //               component: AddLabOrder,
  //               isDisplay: "yes",
  //             },
  //             {
  //               path: "/lab_order_list",
  //               layout: "/admin",
  //               name: "Lab OrderList",
  //               mini: "OD",
  //               icon: "pe-7s-news-paper",
  //               component: LabOrderList,
  //               isDisplay: "yes",
  //             },

  //             {
  //               path: "/laborder/:id",
  //               layout: "/admin",
  //               name: "Edit Lab Order",
  //               mini: "ER",
  //               breadcrumb: "Lab OrderList",
  //               breadcrumbPath: "lab_order_list",
  //               icon: "pe-7s-news-paper",
  //               component: EditLabOrder,
  //               isDisplay: "no",
  //             },
  //             {
  //               path: "/banner",
  //               layout: "/admin",
  //               name: "Banner",
  //               mini: "OBR",
  //               icon: "fa fa-clone",
  //               component: Banner,
  //               isDisplay: "yes",
  //             },
  //             {
  //               path: "/addbanner",
  //               layout: "/admin",
  //               name: "Add Banner",
  //               mini: "OBRA",
  //               icon: "fa fa-clone",
  //               component: AddBanner,
  //               isDisplay: "no",
  //             },
  //             {
  //               path: "/editbanner",
  //               layout: "/admin",
  //               name: "Edit Banner",
  //               mini: "OBRE",
  //               icon: "fa fa-clone",
  //               component: EditBanner,
  //               isDisplay: "no",
  //             },
  //           ],
  //         },
  //         {
  //           collapse: true,
  //           path: "/order ",
  //           name: "Subscription",
  //           state: "openordersubscription",
  //           icon: "pe-7s-note2",
  //           views: [
  //             {
  //               path: "/subscription-add-order/:id",
  //               layout: "/admin",
  //               name: "New Subscription Order ",
  //               breadcrumb: "Subscription OrderList",
  //               breadcrumbPath: "subscription_order_list",
  //               mini: "OR",
  //               icon: "fa fa-clone",
  //               component: addsubscriptionorder,
  //               isDisplay: "no",
  //             },

  //             {
  //               path: "/subscription-add-order",
  //               layout: "/admin",
  //               name: "New Subscription Order ",
  //               breadcrumb: "Subscription OrderList",
  //               breadcrumbPath: "subscription_order_list",
  //               mini: "OR",
  //               icon: "fa fa-clone",
  //               component: addsubscriptionorder,
  //               isDisplay: "yes",
  //             },
  //             {
  //               path: "/subscription_order_list",
  //               layout: "/admin",
  //               name: "Subscription OrderList",
  //               mini: "OD",
  //               icon: "pe-7s-news-paper",
  //               component: subscriptionorderlist,
  //               isDisplay: "yes",
  //             },
  //             {
  //               path: "/subscriptionfilter",
  //               layout: "/admin",
  //               name: "Subscription Details",
  //               mini: "SD",
  //               component: subscriptionpackagefilter,
  //               icon: "fa fa-user",
  //               isDisplay: "yes",
  //             },
  //             {
  //               path: "/subscriptionorder/:id",
  //               layout: "/admin",
  //               name: "Edit Subscription Order",
  //               mini: "ER",
  //               breadcrumb: "Subscription OrderList",
  //               breadcrumbPath: "subscription_order_list",
  //               icon: "pe-7s-news-paper",
  //               component: editsubscriptionOrder,
  //               isDisplay: "no",
  //             },
  //           ],
  //         },
  //         {
  //           path: "/edit_b2b",
  //           layout: "/admin",
  //           name: "Edit B2B",
  //           mini: "BL",
  //           component: Editb2b,
  //           breadcrumb: "B2B",
  //           breadcrumbPath: "viewb2b",
  //           icon: "fa fa-cubes",
  //           isDisplay: "no",
  //         },
  //       ],
  //     },
  //     {
  //       collapse: true,
  //       path: "/management",
  //       name: "Management",
  //       state: "openNewManagement",
  //       icon: "pe-7s-config",
  //       views: [
  //         {
  //           path: "/Customer",
  //           layout: "/admin",
  //           name: "CustomerOrg",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: CustomerList,
  //           isDisplay: "yes",
  //         },
  //         {
  //           path: "/InventoryTab",
  //           layout: "/admin",
  //           name: "Inventory",
  //           mini: "MD",
  //           icon: "fa fa-medkit",
  //           component: InventoryTabList,
  //           isDisplay: "yes",
  //         },
  //         {
  //           path: "/productCatalogue",
  //           layout: "/admin",
  //           name: "ProductCatalogue",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: ProductCatalogueList,
  //           isDisplay: "yes",
  //         },
  //         {
  //           path: "/groups",
  //           layout: "/admin",
  //           name: "Groups",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: ViewGroups,
  //           isDisplay: "yes",
  //         },
  //         {
  //           path: "/appointments",
  //           layout: "/admin",
  //           name: "Appontments",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: ViewAppointmentList,
  //           isDisplay: "yes",
  //         },
  //         {
  //           path: "/couponVoucher",
  //           layout: "/admin",
  //           name: "Coupon & Voucher",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: CouponVoucherList,
  //           isDisplay: "yes",
  //         },
  //         {
  //           collapse: true,
  //           path: "/users",
  //           name: "Users",
  //           state: "openNewUser",
  //           icon: "pe-7s-config",
  //           views: [
  //             {
  //               path: "/userList",
  //               layout: "/admin",
  //               name: "User List",
  //               mini: "LD",
  //               icon: "pe-7s-ball",
  //               component: UserList,
  //               isDisplay: "yes",
  //             },
  //             {
  //               path: "/doctor",
  //               layout: "/admin",
  //               name: "Doctor",
  //               mini: "LD",
  //               icon: "pe-7s-ball",
  //               component: DoctorTab,
  //               isDisplay: "yes",
  //             },
  //           ],
  //         },
  //         {
  //           path: "/heartToHeart",
  //           layout: "/admin",
  //           name: "Heart 2 Heart",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: VoucherDonorLists,
  //           isDisplay: "yes",
  //         },
  //         {
  //           path: "/flashCredit",
  //           layout: "/admin",
  //           name: "Flash Credits",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: FlashCredit,
  //           isDisplay: "yes",
  //         },
  //         {
  //           path: "/appContent",
  //           layout: "/admin",
  //           name: "App Content",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: AppContentTabs,
  //           isDisplay: "yes",
  //         },
  //         {
  //           path: "/poList",
  //           layout: "/admin",
  //           name: "Purchase Order",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: PurchaseOrderList,
  //           isDisplay: "yes",
  //         },
  //       ],
  //     },
  //     {
  //       collapse: true,
  //       path: "/bulk-action",
  //       name: "Bulk Action",
  //       state: "openNewBulkAction",
  //       icon: "pe-7s-config",
  //       views: [
  //         {
  //           path: "/bulk-medicine",
  //           layout: "/admin",
  //           name: "Medicine",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: BulkMedicine,
  //           isDisplay: "yes",
  //         },
  //         {
  //           path: "/bulk-lab",
  //           layout: "/admin",
  //           name: "Lab",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: BulkCustomer,
  //           isDisplay: "yes",
  //         },
  //         {
  //           path: "/bulk-customer",
  //           layout: "/admin",
  //           name: "Customer",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: BulkLab,
  //           isDisplay: "yes",
  //         },
  //       ],
  //     },
  //     {
  //       collapse: true,
  //       path: "/external",
  //       name: "External",
  //       state: "openNewexternal",
  //       icon: "pe-7s-config",
  //       views: [
  //         {
  //           path: "/xero",
  //           layout: "/admin",
  //           name: "External",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: XeroInvoices,
  //           isDisplay: "yes",
  //         },
  //       ],
  //     },
  //     {
  //       collapse: true,
  //       path: "/logs",
  //       name: "Logs",
  //       state: "openNewLogs",
  //       icon: "pe-7s-config",
  //       views: [
  //         {
  //           path: "/app",
  //           layout: "/admin",
  //           name: "App",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: AppLog,
  //           isDisplay: "yes",
  //         },
  //         {
  //           path: "/rider",
  //           layout: "/admin",
  //           name: "Rider",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: RiderLogTab,
  //           isDisplay: "yes",
  //         },
  //         {
  //           path: "/system",
  //           layout: "/admin",
  //           name: "System",
  //           mini: "LD",
  //           icon: "pe-7s-ball",
  //           component: SystemLog,
  //           isDisplay: "yes",
  //         },
  //       ],
  //     },
  //   ],
  // },
];
export default routes;
